// @ts-nocheck
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

// 防止点击重复路由报错
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};
export default new Router({
  routes: [
    {
      path: "/login",
      name: "login",
      meta: {
        menuName: "用户登陆",
        icon: "",
        status: true
      },
      component: () => import("./views/login.vue")
    },
    {
      path: "/",
      name: "home",
      meta: {
        menuName: "首页",
        icon: "",
        status: true
      },
      component: () => import("./views/home/index.vue"),
      children: [
        // {
        //   path: "monitor",
        //   name: "monitor",
        //   meta: {
        //     menuName: "监控管理", // 菜单名称
        //     serverConfigName: "MONITOR", // 后台权限控制ID
        //     icon: "el-icon-ga-jiankong", // 菜单图标
        //     status: true, // 是否可访问，根据后台权限设置，有默认值
        //     notPath: true // 对应路径是否存在页面，过滤一些一级菜单（没有页面，单纯的路径）
        //   },
        //   component: () => import("./components/router.vue"),
        //   children: [
        //     {
        //       path: "host",
        //       name: "host",
        //       meta: {
        //         menuName: "主机",
        //         serverConfigName: "MONITOR",
        //         icon: "el-icon-ga-hdfs",
        //         status: true,
        //         keepAlive: false // 可缓存
        //       },
        //       component: () => import("./views/monitor-host/index.vue")
        //     },
        //     {
        //       path: "hdfs",
        //       name: "hdfs",
        //       meta: {
        //         menuName: "HDFS监控",
        //         serverConfigName: "MONITOR",
        //         icon: "el-icon-ga-hdfs",
        //         status: true,
        //         keepAlive: false // 可缓存
        //       },
        //       component: () => import("./views/monitor-hdfs/index.vue")
        //     },
        //     {
        //       path: "yarn",
        //       name: "yarn",
        //       meta: {
        //         menuName: "YARN监控",
        //         serverConfigName: "MONITOR",
        //         icon: "el-icon-ga-yarn",
        //         status: true,
        //         keepAlive: false // 可缓存
        //       },
        //       component: () => import("./views/monitor-yarn/index.vue")
        //     },
        //     {
        //       path: "hbase",
        //       name: "hbase",
        //       meta: {
        //         menuName: "Hbase监控",
        //         serverConfigName: "MONITOR",
        //         icon: "el-icon-ga-HBASE",
        //         status: true,
        //         keepAlive: false // 可缓存
        //       },
        //       component: () => import("./views/monitor-hbase/index.vue")
        //     },
        //     {
        //       path: "zookeeper",
        //       name: "zookeeper",
        //       meta: {
        //         menuName: "Zookeeper监控",
        //         serverConfigName: "MONITOR",
        //         icon: "el-icon-ga-zookeeper",
        //         status: true,
        //         keepAlive: false // 可缓存
        //       },
        //       component: () => import("./views/monitor-zookeeper/index.vue")
        //     },
        //     {
        //       path: "pesto",
        //       name: "pesto",
        //       meta: {
        //         menuName: "Pesto监控",
        //         serverConfigName: "MONITOR",
        //         icon: "el-icon-ga-jiankong",
        //         status: true,
        //         keepAlive: false // 可缓存
        //       },
        //       component: () => import("./views/monitor-pesto/index.vue")
        //     }
        //   ]
        // },
        {
          path: "filemanage",
          name: "filemanage",
          meta: {
            menuName: "文件管理", // 菜单名称
            serverConfigName: "FILESYSTOM", // 后台权限控制ID
            icon: "el-icon-ga-wjgl", // 菜单图标
            status: true, // 是否可访问，根据后台权限设置，有默认值
            notPath: true // 对应路径是否存在页面，过滤一些一级菜单（没有页面，单纯的路径）
          },
          component: () => import("./components/router.vue"),
          children: [
            {
              path: "filebrowsing",
              name: "filebrowsing",
              meta: {
                menuName: "文件系统",
                serverConfigName: "FILE",
                icon: "el-icon-ga-wjll",
                status: false,
                keepAlive: false // 可缓存
              },
              component: () => import("./views/filebrows/index.vue")
            },
            {
              path: "category",
              name: "category",
              meta: {
                keepAlive: true, // 可缓存
                menuName: "分类管理",
                serverConfigName: "FILEMETA",
                icon: "el-icon-ga-fenleiguanli",
                status: false
              },
              component: () => import("./views/sortmanage/index.vue")
            },
            {
              path: "objectstorage",
              name: "objectstorage",
              meta: {
                menuName: "对象存储",
                serverConfigName: "BUCKET",
                icon: "el-icon-ga-dxcc",
                status: false
              },
              component: () => import("./views/objectstorage/index.vue")
            }
          ]
        },
        {
          path: "dataoperation",
          name: "dataoperation",
          meta: {
            menuName: "数据操作",
            serverConfigName: "DB",
            icon: "el-icon-ga-sjcz",
            status: false,
            notPath: true
          },
          component: () => import("./components/router.vue"),
          children: [
            {
              path: "dataquery",
              name: "dataquery",
              meta: {
                menuName: "数据查询",
                serverConfigName: "",
                icon: "el-icon-ga-sjcx",
                status: true
              },
              component: () => import("./views/dataquery")
            },
            {
              path: "datasource",
              name: "datasource",
              meta: {
                menuName: "数据源管理",
                serverConfigName: "",
                icon: "el-icon-ga-sjkgl",
                status: true
              },
              component: () => import("./views/datasourcemanage/index.vue")
            }
          ]
        },
        {
          path: "datainterface",
          name: "dataopedatainterfaceration",
          meta: {
            menuName: "数据接口",
            serverConfigName: "DiRes",
            icon: "el-icon-ga-apijiekougengxin",
            status: false,
            notPath: true
          },
          component: () => import("./components/router.vue"),
          children: [
            {
              path: "dataentity",
              name: "dataentity",
              meta: {
                menuName: "数据实体",
                serverConfigName: "",
                icon: "el-icon-ga-chanpin",
                status: true
              },
              component: () => import("./views/data-entity")
            },
            {
              path: "datainterface",
              name: "datainterface",
              meta: {
                menuName: "数据接口",
                serverConfigName: "",
                icon: "el-icon-ga-jiekou1",
                status: true
              },
              component: () => import("./views/data-interface")
            }
          ]
        },
        {
          path: "flowmanage",
          name: "flowmanage",
          meta: {
            menuName: "流程管理",
            serverConfigName: "TASK",
            icon: "el-icon-ga-lcgl",
            status: false,
            notPath: true
          },
          component: () => import("./components/router.vue"),
          children: [
            {
              path: "appmanage",
              name: "appmanage",
              meta: {
                menuName: "应用管理",
                serverConfigName: "",
                icon: "el-icon-ga-yygl",
                status: true,
                keepAlive: true
              },
              component: () => import("./views/appmanage/index.vue")
            },
            {
              path: "varmanage",
              name: "varmanage",
              meta: {
                menuName: "变量管理",
                serverConfigName: "",
                icon: "el-icon-ga-bianliang",
                status: true,
                keepAlive: false
              },
              component: () => import("./views/varmanage/index.vue")
            },
            {
              path: "flowInfo",
              name: "flowInfo",
              meta: {
                menuName: "流程信息",
                serverConfigName: "",
                icon: "el-icon-ga-lcxx",
                status: true,
                keepAlive: false
              },
              component: () => import("./views/processinfo/index.vue")
            },
            {
              path: "executions",
              name: "executions",
              meta: {
                menuName: "执行实例",
                serverConfigName: "",
                icon: "el-icon-ga-zxsl",
                status: true,
                keepAlive: false
              },
              component: () => import("./views/impexample/index.vue")
            },
            {
              path: "executors",
              name: "executors",
              meta: {
                menuName: "执行节点",
                serverConfigName: "",
                icon: "el-icon-ga-zxjd",
                status: true,
                keepAlive: true
              },
              component: () => import("./views/executenode/index.vue")
            }
          ]
        },
        {
          path: "pluginmanage",
          name: "pluginmanage",
          meta: {
            menuName: "插件管理",
            serverConfigName: "PLUGIN",
            icon: "el-icon-ga-cjgl",
            status: false,
            notPath: false
          },
          component: () => import("./views/pluginmanage/index.vue")
        },
        {
          path: "notebook",
          name: "notebook",
          meta: {
            menuName: "NoteBook",
            serverConfigName: "NoteBook",
            icon: "el-icon-ga-notebook",
            status: true,
            notPath: false
          },
          component: () => import("./views/notebook/index.vue")
        },
        {
          path: "systemmanage",
          name: "systemmanage",
          meta: {
            menuName: "系统管理",
            serverConfigName: "GAVIALSYSTEM",
            icon: "el-icon-ga-xtgl",
            status: false,
            notPath: true
          },
          component: () => import("./components/router.vue"),
          children: [
            {
              path: "usermanage",
              name: "usermanage",
              meta: {
                menuName: "用户管理",
                serverConfigName: "",
                icon: "el-icon-ga-yhgl",
                status: true,
                keepAlive: true
              },
              component: () => import("./views/usermanage/index.vue")
            },
            {
              path: "groupmanage",
              name: "groupmanage",
              meta: {
                menuName: "组管理",
                serverConfigName: "",
                icon: "el-icon-ga-zgl",
                status: true,
                keepAlive: true
              },
              component: () => import("./views/groupmanage/index.vue")
            }
          ]
        },
        {
          path: "permissionmanage",
          name: "permissionmanage",
          meta: {
            menuName: "权限管理",
            serverConfigName: "GAVIALAUTH",
            icon: "el-icon-ga-qxgl",
            status: false,
            notPath: true
          },
          component: () => import("./components/router.vue"),
          children: [
            {
              path: "authmanage",
              name: "authmanage",
              meta: {
                menuName: "授权管理",
                serverConfigName: "",
                icon: "el-icon-ga-sqgl",
                status: true,
                keepAlive: true
              },
              component: () => import("./views/authormanage/index.vue")
            },
            {
              path: "accesskeymanage",
              name: "accesskeymanage",
              meta: {
                menuName: "AccessKey",
                serverConfigName: "",
                icon: "el-icon-ga-assk",
                status: true,
                keepAlive: true
              },
              component: () => import("./views/accesskey/index.vue")
            }
          ]
        }
      ]
    }
  ]
});
